import { ProjectPremiumContentStatus } from '../../../../../../api/src/project/project.entity';
import { DialogConfig } from '../global/global.model';
import { CartItem } from '../cart/cart.model';
import { ConfirmDialogData } from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ObjectUtils } from '../../../../../../api/src/_core/utils/utils.object';
import { LocaleDto } from '../../../../../../api/src/creative-unit-package/models/locale.dto';

export class BusinessUtils{

	/**
	 * Generates the copy for the free trial purchase dialog.
	 * If the message contains '{{premiumContentItems}}', it replaces it with a list of premium content items.
	 * @param premiumContent - The premium content status containing items.
	 * @param freeTrialPurchaseDialogCopy - The dialog configuration copy.
	 * @param cartItems - The list of cart items to find names from.
	 * @returns ConfirmDialogData with the updated message.
	 */

	public static generateFreeTrialPurchaseDialogCopy(premiumContent: ProjectPremiumContentStatus, freeTrialPurchaseDialogCopy: DialogConfig, cartItems: CartItem[]): ConfirmDialogData {
		let message = freeTrialPurchaseDialogCopy?.message || 'This content requires a subscription. Please set up a subscription to continue.';
		if (message.includes('{{premiumContentItems}}')) {
			const uniqueNames = [];
			const premiumContentItems = premiumContent?.premiumContentItems?.map(item => {
				let name = item.name;
				if (item.cartItemId) {
					const cartItem = cartItems?.find(e => e.id === item.cartItemId);
					if (cartItem) {
						name = ObjectUtils.getLocale(cartItem.metadata?.listingName, (cartItem.locale?.listing as LocaleDto)?.name) || cartItem.name || item.name;
					}
				}
				if (uniqueNames.includes(name)) {
					return null; // Skip duplicates
				}
				uniqueNames.push(name);

				return `<li>${name}</li>`
			});

			message = freeTrialPurchaseDialogCopy?.message?.replace('{{premiumContentItems}}', premiumContentItems?.length ? `<ul>${premiumContentItems.filter(item => !!item).join('')}</ul>` : '');
		}


		return {
			// settings should come from freeTrialPurchaseDialogCopy, setting fallback values
			title: 'You are on a free trial',
			confirm: 'Setup subscription',
			...freeTrialPurchaseDialogCopy,
			message: message,
		}
	}

}
